export enum PromoOriginEnum {
  PRICING = 'PRICING',
  LOYALTY = 'LOYALTY',
  NONE = 'NONE',
}
